import React from 'react'

export default [
  {
    title: '封面图',
    dataIndex: 'cover_path',
    key: 'cover_path',
    render: (text, record) => {
      return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img className="table-img" src={text} />
          <span>{record.title}</span>
        </div>
      )
    }
  },
  {
    title: '收藏数',
    dataIndex: 'collectors_count',
    key: 'collectors_count'
  },
  {
    title: '上架时间',
    dataIndex: 'updated_at',
    key: 'updated_at'
  }
]
